import { z } from "@utils/zod";

import type { IShapeOfField } from "@utils/zod";

export interface IStudentEmailVerificationFormSchema {
  digit1: string;
  digit2: string;
  digit3: string;
  digit4: string;
  digit5: string;
  digit6: string;
}

export const studentEmailVerificationFormInitialValues: IStudentEmailVerificationFormSchema =
  {
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
    digit5: "",
    digit6: "",
  };

export const studentEmailVerificationFormValidationSchema = z.object<
  IShapeOfField<IStudentEmailVerificationFormSchema>
>({
  digit1: z.string().length(1),
  digit2: z.string().length(1),
  digit3: z.string().length(1),
  digit4: z.string().length(1),
  digit5: z.string().length(1),
  digit6: z.string().length(1),
});
